import { AxiosResponse } from 'axios';
import { UseMutateFunction } from 'react-query';
import { ProfilePermissions } from 'reduxStore/reducers/ProfileSlice/types';
import { DocumentDto } from 'services/EdmsService/types';

export interface GenerateContractsTableHeadingsProps {
  getContractById: UseMutateFunction<AxiosResponse<DocumentDto, any>, unknown, string, unknown>;
  subscribe?: (
    id: string,
    number: string,
    name: string,
    date: string,
    concurrencyStamp: string
  ) => void;
  accept?: (id: string, concurrencyStamp: string, name: string) => void;
  permissions?: ProfilePermissions[];
  organizationId?: string;
}

export const ContractTableStatuses: {
  [id: number]: { id: number; name: string; color: string; label?: string };
} = {
  1: {
    id: 1,
    name: 'Ожидает подписания (принятия)',
    color: 'warning',
  },
  2: {
    id: 2,
    name: 'Подписан',
    color: 'success-60',
  },
  3: {
    id: 2,
    name: 'Принят',
    color: 'success-60',
  },
};
